import { useTranslation } from 'react-i18next';
import type { AuthenticationMethod } from 'naban/store';

import type { FetchService } from '@izimi/api';

import { BaseModal } from '../../modals';
import { AuthenticationMethodsList } from './AuthenticationMethodsList';

type Props = {
  fetchService: FetchService;
  onClose?: VoidFunction;
  onItemSelection?: (item: AuthenticationMethod) => void;
};

export const AuthenticationMethodSelectorModal = ({
  fetchService,
  onItemSelection,
  onClose,
}: Props) => {
  const { t } = useTranslation('naban');

  return (
    <BaseModal
      onClose={onClose}
      title={t('authenticationMethods.selector.title')}
      RenderBody={
        <AuthenticationMethodsList onItemSelection={onItemSelection} fetchService={fetchService} />
      }
    />
  );
};
